import Css from "./style.module.scss";

import demoBackground from "assets/demoBackgroundB.jpg";

import * as Icons from "@phosphor-icons/react";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import Platforms from "utils/Platforms";
import React, { useMemo } from "react";
import classNames from "classnames";

const XeroTransactionsPlaceholder = ({ className, withoutBackground }) => {
  const { messages } = useSelector(getTextsData);

  const demoBackgroundStyle = useMemo(() => {
    return Platforms.checkIsTouchDevice() || withoutBackground
      ? {}
      : { backgroundImage: `linear-gradient(rgba(0, 49, 102, 0.3), rgba(0, 49, 102, 0.3)), url(${demoBackground})` };
  }, [withoutBackground]);

  return (
    <div
      className={classNames(Css.xeroTransactionsPlaceholder, withoutBackground && Css.withoutBackground, className)}
      style={demoBackgroundStyle}>
      <div className={Css.card}>
        <Icons.LockSimple className={Css.icon} />
        <div className={Css.title}>{messages.xeroTransactionsOnlyTitle}</div>
        <div className={Css.description}>{messages.xeroTransactionsOnlyDescription}</div>
      </div>
    </div>
  );
};

export default React.memo(XeroTransactionsPlaceholder);
